import axios from "../util/axios";
import Token from "../util/Token";

const COMPANY_URL = "/cms/v2/company";
const TEAM_URL = "/cms/v1/team";

// Fleet settings (Company → Settings → Fleet): fleet mode (Energy Cost instead of
// Revenue on the dashboard), the SoC at which a truck counts as Ready, and each
// charging site's electricity tariff (₹/kWh). Dashboard reads are resilient.

export const DEFAULT_READY_SOC = 80;
const DEFAULT_TEAM_CONFIG = { fleetModeEnabled: false, readySocPct: DEFAULT_READY_SOC };

const toConfig = (d, fallbackReady) => ({
  fleetModeEnabled: d?.fleetModeEnabled === true,
  readySocPct: d?.readySocPct == null ? fallbackReady : Number(d.readySocPct),
});

// Effective settings for the team the dashboard is showing (inherited from the parent).
async function getTeamFleetConfig(teamId) {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get(`${TEAM_URL}/${teamId}/fleet-config`);
    if (status === 200 && data.success) return toConfig(data.data, DEFAULT_READY_SOC);
    return DEFAULT_TEAM_CONFIG;
  } catch (error) {
    return DEFAULT_TEAM_CONFIG;
  }
}

// A company's OWN settings; readySocPct null = not set (inherits / defaults to 80).
async function getCompanyFleetConfig(companyId) {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get(`${COMPANY_URL}/${companyId}/fleet-config`);
    if (status === 200 && data.success) return toConfig(data.data, null);
    return toConfig(null, null);
  } catch (error) {
    return toConfig(null, null);
  }
}

async function updateCompanyFleetConfig(companyId, { fleetModeEnabled, readySocPct }) {
  Token.setAuthToken();
  const { data } = await axios.put(`${COMPANY_URL}/${companyId}/fleet-config`, {
    fleetModeEnabled: fleetModeEnabled === true,
    readySocPct: readySocPct ?? null,
  });
  return toConfig(data?.data, null);
}

// [{ zoneId, zoneName, electricityTariff }] for the company and its teams.
async function getCompanySiteTariffs(companyId) {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get(`${COMPANY_URL}/${companyId}/site-tariffs`);
    return status === 200 && data.success ? data.data?.sites || [] : [];
  } catch (error) {
    return [];
  }
}

async function updateCompanySiteTariff(companyId, zoneId, electricityTariff) {
  Token.setAuthToken();
  const { data } = await axios.put(`${COMPANY_URL}/${companyId}/site-tariffs/${zoneId}`, {
    electricityTariff: electricityTariff ?? null,
  });
  return data?.data;
}

const fleetConfigService = {
  getTeamFleetConfig,
  getCompanyFleetConfig,
  updateCompanyFleetConfig,
  getCompanySiteTariffs,
  updateCompanySiteTariff,
};

export default fleetConfigService;
